'use client';

import { Checkbox, Field, Label } from '@headlessui/react';
import { Ref, useState, useEffect } from 'react';
import { VariantProps } from 'tailwind-variants';

import { styles } from './UiKitCheckboxTag.styles';

type Variants = VariantProps<typeof styles>;

export interface UiKitCheckboxTagProps {
  name?: string;
  label: React.ReactNode;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  checked?: boolean;
  ref?: Ref<HTMLButtonElement>;
  className?: string;
  color?: Variants['color'];
  value?: string;
  editable?: boolean;
}

export function UiKitCheckboxTag({
  label,
  disabled,
  onChange,
  checked: initialChecked,
  ref,
  className,
  color,
  editable = true,
  ...props
}: UiKitCheckboxTagProps) {
  const [checked, setChecked] = useState(initialChecked ?? false);
  const slots = styles({ disabled, checked, color });

  useEffect(() => {
    setChecked(initialChecked ?? false);
  }, [initialChecked]);

  const handleChange = (checked: boolean) => {
    setChecked(checked);
    onChange?.(checked);
  };

  return (
    <Field
      className={slots.base()}
      disabled={disabled || !editable}
    >
      <div className={slots.checkboxContainer()}>
        <Checkbox
          ref={ref}
          onChange={handleChange}
          className={slots.checkbox()}
          checked={checked}
          {...props}
        />
        <Label className={slots.label({ className })}>{label}</Label>
      </div>
    </Field>
  );
}
